/**
 * Created by henriquemasca on 10/4/19.
 */

//import Const from './consts';
import axios from 'axios';

const API_client_id = "26ab60c2-dcf9-4811-bf11-719772a51c0e";
const API_token = "1c37119a-b4b9-4d80-b333-2a0013b12945";
const API_auth =  "659d510ef91304f344e55198f83d1d5a62b859033e6c0b9b07c3e6eb529b1343";

//Chaves de teste
//const API_client_id = "ce4ae141-6bc9-4162-b867-719a2a380d4c";
//const API_token = "508f3ba6-2712-4daf-9ec6-40046b3bfe88";
//const API_auth =  "e430c1a295decce1428ddf56b4cc52342f583c258038b1e3d5bb2c28c68397de";

//Chaves de producao
//const API_client_id = "26ab60c2-dcf9-4811-bf11-719772a51c0e";
//const API_token = "1c37119a-b4b9-4d80-b333-2a0013b12945";
//const API_auth =  "659d510ef91304f344e55198f83d1d5a62b859033e6c0b9b07c3e6eb529b1343";

//Chaves de producao
//client_id: 26ab60c2-dcf9-4811-bf11-719772a51c0e
//token: 1c37119a-b4b9-4d80-b333-2a0013b12945
//auth: 659d510ef91304f344e55198f83d1d5a62b859033e6c0b9b07c3e6eb529b1343

class ApiRateio {
	
	constructor() {
		this.axiosRateio = axios.create({});
	}
	
    getUserList(user_email) {
        //delete axios.defaults.headers.common['Authorization'];
        
        this.axiosRateio.defaults.headers.common['auth'] = API_auth;
        this.axiosRateio.defaults.headers.common['token'] = API_token;
        
        return this.axiosRateio.get(`https://pay.rateiodigital.com.br/clients/${API_client_id}/users?email=${user_email}`);
    }
    
    getUser(user_id) {
        //delete this.axiosRateio.defaults.headers.common['Authorization'];
        
        //debugger;
        
        this.axiosRateio.defaults.headers.common['auth'] = API_auth;
        this.axiosRateio.defaults.headers.common['token'] = API_token;
        
        return this.axiosRateio.get(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users/${user_id}`);
    }
    
    createUser(userObj) { // ???
    	
    	this.axiosRateio.defaults.headers.common['auth'] = API_auth;
	    this.axiosRateio.defaults.headers.common['token'] = API_token;
	    
    	
    	return this.axiosRateio.post(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users`, userObj);
    	
    	
    };
    
    getCards(user_id) {
    	//delete this.axiosRateio.defaults.headers.common['Authorization'];
    	
    	this.axiosRateio.defaults.headers.common['auth'] = API_auth;
	    this.axiosRateio.defaults.headers.common['token'] = API_token;
	    
    	return this.axiosRateio.get(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users/${user_id}/cards`);
    	
    };
	
    createCard(user_id, cardObj) {
    	
    	this.axiosRateio.defaults.headers.common['auth'] = API_auth;
	    this.axiosRateio.defaults.headers.common['token'] = API_token;
	    
    	
    	return this.axiosRateio.post(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users/${user_id}/cards`, cardObj);
    
    };
    
    removeCard(user_id, id) {
    	
    	this.axiosRateio.defaults.headers.common['auth'] = API_auth;
	    this.axiosRateio.defaults.headers.common['token'] = API_token;
	    
	    return this.axiosRateio.delete(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users/${user_id}/cards/${id}`);
	    
    }
    
    createNewPayment(user_id, transObj) {
    	
    	this.axiosRateio.defaults.headers.common['auth'] = API_auth;
	    this.axiosRateio.defaults.headers.common['token'] = API_token;
	    
	    console.log('Headers createNewPayment: ', axios.defaults.headers);
	    
	    return this.axiosRateio.post(`https://pay.rateiodigital.com.br//clients/${API_client_id}/users/${user_id}/payments`, transObj);
	    
    };
}

export default new ApiRateio();


// WEBPACK FOOTER //
// ./src/utils/api.rateio.js